const globalState = ()=>({})
export default globalState


// WEBPACK FOOTER //
// ./reducers/globalState.js